module.exports = __webpack_public_path__ + "img/170.9ca7b144.jpg";